const shippopUrl =
  'https://play.google.com/store/apps/details?id=com.shippop.SHIPPOP&utm_source=shippop-www&utm_campaign=shippop-www&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
const shippopProUrl =
  'https://play.google.com/store/apps/details?id=com.shippop.printer&utm_source=shippop-www&utm_campaign=shippop-www&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'

const PlayStoreBadge = ({
  width = 200,
  shippopType = 'shippop',
  style,
  ...otherProps
}) => {
  return (
    <a
      href={shippopType === 'shippopPro' ? shippopProUrl : shippopUrl}
      target="_blank"
      style={{ width: width, padding: 10, ...style }}
      {...otherProps}
    >
      <img
        style={{ width: width - 20 }}
        alt="ดาวน์โหลดได้จาก Google Play"
        src="/static/img/shippop-app/google_play_badge.svg"
      />
    </a>
  )
}

export default PlayStoreBadge
